const cdnBaseUrl = import.meta.env.PROD ? 'https://cdn.projethabitation.com' : 'https://cdn.dev.projethabitation.com';

export const Constants = {
  ImageSizes: {
    ExtraLarge: {
      Width: 1920,
      Height: 1280,
    },
    Large: {
      Width: 960,
      Height: 640,
    },
    Medium: {
      Width: 480,
      Height: 320,
    },
    Small: {
      Width: 240,
      Height: 160,
    },
  },
  Breakpoints: {
    '2xs': 'var(--breakpoint-2xs)',
    xs: 'var(--breakpoint-xs)',
    sm: 'var(--breakpoint-sm)',
    md: 'var(--breakpoint-md)',
    lg: 'var(--breakpoint-lg)',
    xl: 'var(--breakpoint-xl)',
    '2xl': 'var(--breakpoint-2xl)',
    '3xl': 'var(--breakpoint-3xl)',
    '4xl': 'var(--breakpoint-4xl)',
  },
  BreakpointWidths: {
    md: 768,
    lg: 1024,
  },
  CdnBaseUrl: cdnBaseUrl,
  ProjectNoImageSrc: {
    src: `${cdnBaseUrl}/placeholders/project-image.webp`,
    title: '',
  },
  ProjectModelNoImageSrc: {
    src: `${cdnBaseUrl}/placeholders/project-model-image.webp`,
    title: '',
  },
  PriceTypeId: {
    ForSale: 1,
    ForRent: 2,
  },
  RegionId: {
    Montreal: 6,
    Laval: 13,
  },
  // Libellé de type de propriété utilisé dans le titre des pages de projet, par identifiant de
  // catégorie globale. Les sous-catégories retombent sur le libellé de leur catégorie racine, comme
  // le font déjà les pages éditoriales. Le libellé est porté au complet parce que « neuf » ne
  // s'accorde pas à tout : un terrain n'est pas neuf et une maison usinée ne se dit jamais neuve.
  ProjectTitlePropertyTypes: {
    1: 'houses', // Maison
    2: 'condos', // Condo
    3: 'multiplexes', // Multiplex
    4: 'manufactured-houses', // Maison usinée
    5: 'lands', // Terrain
    6: 'senior-residences', // Résidence pour personnes âgées
    10: 'houses', // Bungalow
    11: 'houses', // Cottage
    12: 'houses', // Maison jumelée
    14: 'houses', // Maison de ville
    15: 'houses', // Maison bigénérationnelle
    16: 'condos', // Loft
    17: 'condos', // Penthouse
    18: 'multiplexes', // Duplex
    19: 'multiplexes', // Triplex
    20: 'multiplexes', // Quadruplex
    21: 'multiplexes', // Quintuplex
    22: 'multiplexes', // Sixplex
  } as Record<number, string | undefined>,
  // Ancres vers lesquelles le routeur accepte de faire défiler.
  // Le scrollBehavior ignore volontairement toutes les autres, car la page de projet
  // se sert du hash comme état de sélection et ne doit jamais sauter.
  ScrollAnchors: {
    EditorialChildLocations: 'villes',
    BuilderArticles: 'articles',
  },
  // Nombre minimal de constructeurs pour qu'une page de constructeurs soit indexable
  // et listée dans le sitemap. Doit rester aligné sur BuildersLocationMinimumCount
  // dans backend/src/ProjetHabitation.Public.Server/Common/SitemapExtensions.cs.
  BuildersLocationMinimumCount: 5,
  // Cadrage initial des cartes, remplacé dès que les pins sont connus.
  DefaultMapCenter: {
    Latitude: 46.8139,
    Longitude: -71.208,
    Zoom: 6,
  },
  // Interrupteurs de fonctionnalités. Mettre à true pour activer.
  Features: {
    // Widget d'aide affiché quand une page éditoriale ne trouve aucun projet.
    EditorialHelpWidget: true,
    // Carte des projets sur les pages éditoriales de lieu.
    EditorialProjectsMap: true,
  },
} as const;
